import { getToken, main_url } from "../../../utilis/Common";

const apiBase = () => `${main_url().replace(/\/+$/, "")}/api/v1`;

/**
 * @param {string} documentType
 * @param {{ rawText: string }} rawOcr
 * @param {string[]} fields
 */
export const createOcrJob = async (documentType, rawOcr, fields) => {
  const token = getToken();
  const headers = {
    "Content-Type": "application/json",
    Accept: "application/json",
  };

  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }

  const response = await fetch(`${apiBase()}/ocr/jobs`, {
    method: "POST",
    headers,
    body: JSON.stringify({
      document_type: documentType,
      raw_ocr: {
        rawText: rawOcr.rawText || "",
      },
      fields,
    }),
  });

  const data = await response.json().catch(() => ({}));

  if (response.status === 422) {
    const message =
      data?.message ||
      Object.values(data?.errors || {})
        .flat()
        .join(" ") ||
      "Invalid OCR job request.";
    throw new Error(message);
  }

  if (response.status === 401 || response.status === 403) {
    throw new Error("You are not authorized to run document extraction.");
  }

  if (!response.ok) {
    throw new Error(data?.message || `OCR job request failed (${response.status}).`);
  }

  if (!data?.id) {
    throw new Error("OCR job did not return a job id.");
  }

  return data;
};

/**
 * @param {string} jobId
 */
export const fetchOcrJob = async (jobId) => {
  const token = getToken();
  const headers = { Accept: "application/json" };

  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }

  const response = await fetch(`${apiBase()}/ocr/jobs/${jobId}`, {
    method: "GET",
    headers,
  });

  const data = await response.json().catch(() => ({}));

  if (response.status === 404) {
    throw new Error("OCR job not found.");
  }

  if (response.status === 401 || response.status === 403) {
    throw new Error("You are not authorized to view this extraction job.");
  }

  if (!response.ok) {
    throw new Error(data?.message || `Failed to fetch OCR job (${response.status}).`);
  }

  return data;
};
